import React from 'react';
import {WineInfoAQ} from '../../components/modules/accordion/WineInfo';
import {WineTerroirAQ} from '../../components/modules/accordion/WineTerroir';
import {WineCellerAQ} from '../../components/modules/accordion/WineCeller';
import {WineEttColtAQ} from '../../components/modules/accordion/WineEttColt';
import {WineBottlesAQ} from '../../components/modules/accordion/WineBottles';

function Aquila({data}) {
    return (
        <>
            {data[0] && <WineInfoAQ />}
            {data[1] && <WineTerroirAQ />}
            {data[2] && <WineCellerAQ />}
            {data[3] && <WineEttColtAQ />}
            {data[4] && <WineBottlesAQ />}
        </>
    )
}

export default Aquila;
